import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/care-team")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/patient/$patientId/care-team"!</div>;
}
